import { useEffect } from "react";
import { useParams } from "react-router-dom";

function SitemapView() {
  const { name } = useParams();

  useEffect(() => {
    const apiPath = name ? `/api/sitemap/${name}.xml` : "/api/sitemap.xml";

    fetch(apiPath)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to load sitemap");
        }
        return res.text();
      })
      .then((xmlData) => {
        // Render as plain, unstyled XML text display inside a clean pre block to show all tags (<loc>, etc)
        const escapedXml = xmlData
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");

        document.open("text/html");
        document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Sitemap XML</title>
            </head>
            <body style="margin: 0; background: #ffffff;">
              <pre style="word-wrap: break-word; white-space: pre-wrap; margin: 0; padding: 20px; font-family: monospace; font-size: 13px; line-height: 1.5; color: #000000;">${escapedXml}</pre>
            </body>
          </html>
        `);
        document.close();
      })
      .catch((err) => {
        console.error("Sitemap error:", err);
        document.open("text/html");
        document.write("<h3>Sitemap not found or failed to load.</h3>");
        document.close();
      });
  }, [name]);

  return null;
}

export default SitemapView;
